import Vue from 'vue';
import Router from 'vue-router';
import paths from './paths';
import NProgress from 'nprogress';
import axios from 'axios';
import 'nprogress/nprogress.css';

Vue.use(Router);

let filteredRouters = paths;
let adminRouters = paths.filter((route) => route.type === 'admin');
let userRouters = paths.filter((route) => route.type === 'user');

axios.get('/api/auth/check/admin/server').then((response) => {
  console.log('isAdmin response:', response.data);

  if (response.data === '2') {
    // 모든 페이지 접속 가능 하도록 할 경우
    userRouters.forEach((route) => router.addRoute(route));
    adminRouters.forEach((route) => router.addRoute(route));
  } else if (response.data === true) {
    // 관리자 페이지 인 경우 path의 isAdmin이 true 인 router만 포함 되도록 처리
    console.log(adminRouters)
    adminRouters.forEach((route) => router.addRoute(route));
  } else {
    // 일반 사용자 페이지인 경우
    userRouters.forEach((route) => router.addRoute(route));
  }

  // router.addRoutes(filteredRouters);
});

const router = new Router({
  base: '/',
  mode: 'history', // hash 에서 바꿔줌 # 없애기 위해서
  linkActiveClass: 'active',
  routes: paths.filter((p) => p.type === 'common'), // 공통 페이지 먼저 라우팅
});
// router gards
router.beforeEach((to, from, next) => {
  NProgress.start();
  next();
});

router.afterEach((to, from) => {
  // ...
  NProgress.done();
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js